import { useState, useEffect } from 'react';
import { useApi } from '../api';
import { useTranslation } from 'react-i18next';

export interface DashboardStats {
  total_products: number;
  available_translations: number;
  total_languages: number;
  active_products: number;
}

export const useDashboardStats = () => {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const api = useApi();
  const { t } = useTranslation();

  const fetchStats = async () => {
    try {
      setLoading(true);
      setError(null);
      const data: DashboardStats = await api.get('/stats/dashboard');
      setStats(data);
    } catch (err) {
      setError(t('errors.fetchFailed'));
      console.error('Error fetching dashboard stats:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, [api, t]);

  return { stats, loading, error, refetch: fetchStats };
};
